export enum EMetodoReceitaBrutaCalculada {
  PRECO_CORRENTE = 1,
  VALOR_REFERENCIA = 2,
}

export enum EDiscriminadorMetodoReceitaBrutaCalculada {
  PRECO_CORRENTE = 'precoCorrente',
  VALOR_REFERENCIA = 'valorProducaoTotal',
}
